import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { take } from 'rxjs/operators';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { SuccessGenericoComponent } from '../../../components/success-generico/success-generico.component';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { ConfirmaExclusaoComponent } from '../confirma-exclusao/confirma-exclusao.component';
import { ErrorGenericoComponent } from '../../../components/error-generico/error-generico.component';
import { FormsModule } from '@angular/forms';
import { SelectComponent } from '../../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AsyncPipe } from '@angular/common';
import { CamelCasePipe } from '../../../pipes/camel-case.pipe';
import { UsuarioPermissaoPipe } from '../../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-dados-empresa-enderecos',
    templateUrl: './dados-empresa-enderecos.component.html',
    styleUrls: ['./dados-empresa-enderecos.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SuccessGenericoComponent, LoadingGenericoComponent, ConfirmaExclusaoComponent, ErrorGenericoComponent, FormsModule, SelectComponent, NgxPaginationModule, RouterLink, AsyncPipe, CamelCasePipe, UsuarioPermissaoPipe]
})
export class DadosEmpresaEnderecosComponent implements OnInit {

  public idEmpresaLogada: string = localStorage.idEmpresaLogada;
  public dadosEndereco: any = null;
  public dadosEnderecoBackup: any = null;
  public enderecosPorPagina = '6';
  public paginaEndereco: number = 1;
  public idEnderecoInativado: number;

  // MANIPULAÇÃO DE ALERTS
  public alertConfirmacao: boolean = false;
  public alertSucesso: boolean = false;
  public alertLoading: boolean = false;
  public alertError: boolean = false;

  // INPUT BUSCA ENDEREÇOS
  public campoInput: string;
  public buscaFiltrada: boolean = false;

  constructor(
    private readonly service: DadosEmpresaService,
    public router: Router
    ) { }

  ngOnInit(): void {

    if(sessionStorage.DadosEmpresaEnderecosPagina && sessionStorage.DadosEmpresaEnderecosQtdePorPagina) {
      this.paginaEndereco = sessionStorage.DadosEmpresaEnderecosPagina;
      this.enderecosPorPagina = sessionStorage.DadosEmpresaEnderecosQtdePorPagina;
      sessionStorage.removeItem('DadosEmpresaEnderecosPagina');
      sessionStorage.removeItem('DadosEmpresaEnderecosQtdePorPagina');
    }

    this.consultaEnderecos();
  }

  consultaEnderecos() {

    this.dadosEndereco = null;

    this.service.getDadosEmpresa(this.idEmpresaLogada)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if(response.status === 'OK') {
          this.dadosEndereco = response.response.enderecos;
          this.dadosEnderecoBackup = response.response.enderecos;
        } else { this.dadosEndereco = false; }
      },
      error: (error: any) => {
        this.dadosEndereco = false;
        console.error(error);
      }
    });
  }

  buscaFiltradaPorInput() {
    if (this.campoInput?.length) {
      this.buscaFiltrada = true;
      this.dadosEndereco = this.dadosEnderecoBackup;
      this.paginaEndereco = 0;

      const enderecosFiltrados: any = this.dadosEndereco.filter(endereco => {
        return endereco.fullDescription.toLowerCase().includes(this.campoInput.toLowerCase());
      });

      this.dadosEndereco = enderecosFiltrados;

    } else {
      this.buscaFiltrada = false;
      this.dadosEndereco = this.dadosEnderecoBackup;
    }
  }

  limparFiltro() {
    this.buscaFiltrada = false;
    this.campoInput = '';
    this.dadosEndereco = this.dadosEnderecoBackup;
  }

  // PASSO 1 - MOSTRA O ALERT PERGUNTANDO SE QUER CONFIRMAR A INATIVACAO, SE CONFIRMAR AVANÇA
  confirmaInativacao(idEndereco: number) {
    this.idEnderecoInativado = idEndereco;
    this.alertConfirmacao = true;
  }

  // SE CONFIRMAR NO ALERT ELE CHAMA A FUNÇÃO INATIVARENDERECO, se não, NÃO FAZ NADA
  fecharAlertConfirmacao(evento: string) {
    // Se clicar no botão de CONFIRMAR ele chama a função pra excluir
    if(evento === 'Confirmar') {
      this.alertConfirmacao = false;
      this.inativarEndereco();
    } else { // Se não apenas fecha o alert de confirmação e não faz nada
      this.alertConfirmacao = false;
    }

  }

  inativarEndereco() {

    this.alertLoading = true;

    this.service.inactivateEndereco(this.idEmpresaLogada, this.idEnderecoInativado)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.alertLoading = false;
        this.alertSucesso = true;
        this.consultaEnderecos();
      },
      error: (error: any) => {
        console.error(error);
        this.alertLoading = false;
        this.alertError = true;
      }
    });
  }

  // Fechar o alerta de sucesso, clicando no botão OK
  fecharAlertSucesso(evento: string) {
    this.consultaEnderecos();
    this.alertSucesso = false;
  }

  // Fechar o alerta de erro, clicando no botão OK
  fecharAlertError(evento: string) { this.alertError = false; }

  // Função que leva para a página de edição de endereço passando o id pela rota
  editarEndereco(idEndereco: number) {
    sessionStorage.DadosEmpresaEnderecosPagina = this.paginaEndereco;
    sessionStorage.DadosEmpresaEnderecosQtdePorPagina = this.enderecosPorPagina;
    this.router.navigate(["editar-endereco"], {queryParams: { idEndereco: idEndereco }});
  }

  onEnderecosPorPaginaChange(value : string){
    this.enderecosPorPagina = value;
    this.paginaEndereco = 1;
  }
}
